<template>
  <div>
    <page-table :code="params.code" />
  </div>
</template>
<script>
import PageTable from "./components/table"
export default {
  name: "master-Icechopslog",
  components: { PageTable },
  computed: {
    params() {
      return this.$route.params
    },
  },
  methods: {},
}
</script>
<style></style>
